import PanoPlayer from './PanoPlayer'

export default PanoPlayer
